<ul class="breadcrumb-list">
  <li>
    <a href="{{ controller }}">
      <tui-icon icon="home"/>
    </a>
  </li>

  @for (breadCrumb of breadCrumbs | async; track breadCrumb.id; let i = $index) {
    <li>
        <tui-icon icon="chevron-right" class="sep"/>

      @if (breadCrumb.span) {
        <span>
          {{ breadCrumb.header }}
        </span>
      } @else {
        <a [routerLink]="link(breadCrumb)" [queryParams]="params(breadCrumb)">
          {{ breadCrumb.header }}
        </a>
      }
    </li>
  }
</ul>
